
// enum for type of profile page you are visiting
export enum ProfileVisibilityTypeEnum {
    PublicProfile,
    MyProfile
  }